/**
 * Get file extension from a file name.
 *
 * If there is no extension, it returns an empty string.
 * If there are multiple dots in the file name, it returns the last part after the last dot.
 *
 * Case in-sensitive, so it will return 'jpg' for 'image.JPG' or 'image.jpg'.
 */
export const parseFileExtension = (fileName: string): string => {
    const re = /(?:\.([^.]+))?$/;
    const match = re.exec(fileName);
    return match && match[1] ? match[1].toLowerCase() : '';
}

export const imageFileExtensions = ['jpg', 'jpeg', 'png', 'gif'];
export const pdfFileExtensions = ['pdf'];

export const isImageFile = (fileName: string): boolean => {
    const extension = parseFileExtension(fileName);
    return imageFileExtensions.includes(extension);
};

export const IsPdfFile = (fileName: string): boolean => {
    const extension = parseFileExtension(fileName);
    return pdfFileExtensions.includes(extension);
};
